import { Workflow } from "src/models/workflow";
import { createEntityModel } from "src/store/models/entity/_shared";

export const WorkflowEntityModel = createEntityModel<Workflow>();
